<script>
    import AutoComplete from '../../common/AutoComplete.svelte';
    import Spinner from '../../Spinner.svelte';
    import {submit} from '../../../utils.js';
    import {updateLocalWorksequence} from '../RoleSequenceList/utils.js';
    import {activityVersion, roles} from '../workspacesStore.js';
    import {sgettext} from '../../../i18n.js';

    export let context = null;
    export let actionApi;

    let name = '';
    let isFocused = false;
    let saving = false;


    function onFocus(event){
        isFocused = true;
    }

    function onBlur(event){
        isFocused = false;
        if (name){
            createNewSequence();
        }
    }


    async function createNewSequence(){
        saving = true;
        const data = {
            role_id: context.id,
            schematic_id: 0,
            activity_version_id: $activityVersion.id,
            name
        }
        const resp = await submit(actionApi, 'POST', data, null, false);

        if(resp.ok){
            const json = await resp.json();
            roles.set(updateLocalWorksequence($roles, context.id, null, null, json));
            name = '';
        }
        saving = false;
    }

    function onEnterPressed(event){
        createNewSequence();
    }

</script>

<style>
    .add-sequence-wrapper {
        color: #858585;
        display: flex;
        align-items: center;
    }

    .add-sequence-wrapper :global(input) {
        background-color: transparent;
    }

    .icon {
        margin-right: 5px;
    }

    :global(.data-grid) .list-form {
        border-bottom: none;
    }

    :global(.data-grid) .list-form.focused {
        border: 1px solid #018982;
        background-color: #edf8f6;
    }

    .list-form {
        padding: 15px;
        border: 1px solid #dee2e6;
    }

    .spinner-wrapper {
        padding: 5px;
        display: flex;
    }
</style>
<div
        class:focused={isFocused}
        class="list-form">
    <div class="add-sequence-wrapper static">
        <span class="icon"><i class="fas fa5-plus-square"></i></span>
        <AutoComplete
                bind:value={name}
                placeholder={sgettext("$$ADD_SEQUENCE$$")}
                border={false}
                on:focus={onFocus}
                on:blur={onBlur}
                on:enterPressed={onEnterPressed}
        />
        {#if saving}
        <div class="spinner-wrapper">
            <Spinner size="small" inline={true} />
        </div>

        {/if}
    </div>
</div>
